<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/invoice-apply/table">开票管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel>
      <span slot="header">开票抵扣-BO审批</span>
      <el-form ref="form"
               :model="form"
               size="medium"
               label-width="140px">
        <div class="medium"
             style="width: auto">
          <!-- 开票详情 -->
          <InvoiceApplyInfo :form="form"/>

          <!-- 开票发票列表 -->
          <InvoiceDetailsList :form="form"/>

          <!-- 开票状态 -->
          <InvoiceStatusLayout :form="form"/>
        </div>
      </el-form>
    </layout-panel>

    <layout-panel v-if="form.deduction_detail.length > 0">
      <span slot="header">抵扣详情</span>
      <InvoiceDeductLayout :form="form"/>
    </layout-panel>
  </div>
</template>

<script>
import InvoiceApplyInfo from '../../components/InvoiceApplyInfo'
import InvoiceDetailsList from '../../components/InvoiceDetailsList'
import InvoiceStatusLayout from '../../components/InvoiceStatusLayout'
import InvoiceDeductLayout from '../../components/InvoiceDeductLayout'

export default {
  components: {
    InvoiceApplyInfo,
    InvoiceDetailsList,
    InvoiceStatusLayout,
    InvoiceDeductLayout,
  },
  data () {
    return {
      form: {
        deduction_detail: [],
        attached_file: [],
        log: [],
        cc: [],
        red_flush_attached_file: [],
        detail: [],
        received_details: [],
        split_list: [],
      },
    }
  },
  async created () {
    this.setForm(this.$route.params.id)
  },
  watch: {},
  computed: {
    ...Vuex.mapState({}),
  },
  methods: {
    ...Vuex.mapActions([]),
    setForm (id) {
      request.page('getInvoiceApplyDetail', {id}).then(({data}) => {
        this.form = data
      })
    },
  }
}
</script>


<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/invoice-apply/pages/approve/InvoiceDeductBuReview.vue